<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Related Tasks</span>
    <button
      class="navbar-toggler"
      type="button" data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          class="m-1 mr-2"
          type="button"
          color="primary"
          mat-raised-button
          (click)="onEdit()"
          *ngIf="canCreateTasks"
          matTooltip="Click this button to create a new task.">
          <mat-icon>add</mat-icon>
          Add Task
        </button>

        <!-- The menu only holds Select All and the bulk delete, so both the menu and its trigger are
             wrapped in the delete guard. A mat-menu left outside the guard would still be rendered
             into the CDK overlay. -->
        <ng-container *ngIf="canDeleteTasks">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
              <mat-icon>delete</mat-icon> Delete Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Asset Tasks." style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search the tasks by name."/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>

    </div>
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle select all records.">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let action">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(action.id) : null"
            [checked]="dataSource.selection.isSelected(action.id)"
            matTooltip="Toggle select this record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the task.">
          #
        </th>
        <td mat-cell *matCellDef="let action">
          {{ action.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the task.">
          Task
        </th>
        <td mat-cell *matCellDef="let action">
          {{ action.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the type of task.">
          Type
        </th>
        <td mat-cell *matCellDef="let action">
          {{ action.type }}
        </td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef>
          Priority
        </th>
        <td mat-cell *matCellDef="let action">
          {{ action.priority | titlecase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="due">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the due date of the task.">
          Due Date
        </th>
        <td mat-cell *matCellDef="let action">
          <span *ngIf="action.due">
            {{ action.due | timezoneConvertMedium }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="due_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the due date of the task.">
          Due Date (UTC)
        </th>
        <td mat-cell *matCellDef="let action">
          <span *ngIf="action.due">
            {{ action.due | timezoneConvertUTCMedium }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="completed">
        <th mat-header-cell *matHeaderCellDef>
          Completed
        </th>
        <td mat-cell *matCellDef="let action">
          {{ action.completed ? 'Yes' : 'No' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="users">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Assigned Users
        </th>
        <td mat-cell *matCellDef="let action" class="no-padding">
          <ng-container *ngIf="action?.users?.length">
            <span *ngFor="let user of action.users | slice:0:MAX_VISIBLE_ASSIGNED_USERS">
              <a (click)="onUserPublicView(user.hash)" matTooltip="View User Public Profile">
                {{ user.contact_person }}
              </a><br>
            </span>
            <span *ngIf="action.users.length > MAX_VISIBLE_ASSIGNED_USERS" [matTooltip]="getRemainingUsersTooltip(action.users)">
              {{ action.users.length - MAX_VISIBLE_ASSIGNED_USERS }} more users
            </span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the task was added.">
          Created At
        </th>
        <td mat-cell *matCellDef="let action">
          {{ (action.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the task was added.">
          Created At (UTC)
        </th>
        <td mat-cell *matCellDef="let action">
          {{ (action.date_created * 1000) | timezoneConvertUTCMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>
        <td mat-cell *matCellDef="let action">
          <button type="button" mat-button (click)="onView(action)" *ngIf="canViewTasks">
            View
          </button>
          <button type="button" mat-button class="mr-3" (click)="onEdit(action)" *ngIf="canEditTasks">
            Edit
          </button>
          <button type="button" mat-button (click)="onRemove(action)" *ngIf="canDeleteTasks">
            Delete
          </button>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>

